
import { useToggleRecordMutation } from 'services';
import { ScreenRecordDto } from 'types';

export function useToggleScreenRecord() {


    const [toggleRecord, { isLoading, error }] = useToggleRecordMutation();

    const onToggleScreenRecordHandle = async (values: ScreenRecordDto) => {
        try {
            toggleRecord(values)
                .unwrap()
                .then((res: any) => {
                    // dispatch(setProfile(res.profile));

                })
                .catch((err: any) => console.error(err));
        } catch (err) {
        }
    };
    return {
        isLoading,
        error,
        onToggleScreenRecordHandle
    };
}
